package com.ervasstudio.tracoemovimento.components.custumcomponents.layout

import androidx.compose.runtime.Composable
import com.ervasstudio.tracoemovimento.components.custumcomponents.BotaoDesfalecido
import com.ervasstudio.tracoemovimento.components.custumcomponents.BotaoEstilizado
import com.ervasstudio.tracoemovimento.model.Paginas


@Composable
fun MenuAuht(
    currentPath: String,
    onClick: (rota: String) -> Unit,
    isMobile: Boolean = false,
) {

    when {
        currentPath.contains("login") -> {
            BotaoEstilizado(nome = Paginas.LOGIN.name, isMobile = isMobile)

            BotaoDesfalecido(
                nome = Paginas.SIGNUP.name,
                rota = Paginas.SIGNUP.rota,
                onClick = { onClick(Paginas.SIGNUP.rota) },
                isMobile = isMobile
            )
        }

        currentPath.contains("signup") -> {
            BotaoDesfalecido(
                nome = Paginas.LOGIN.name,
                rota = Paginas.LOGIN.rota,
                onClick = { onClick(Paginas.LOGIN.rota) },
                isMobile = isMobile
            )

            BotaoEstilizado(nome = Paginas.SIGNUP.name, isMobile = isMobile,)
        }

        else -> {
            BotaoDesfalecido(
                nome = Paginas.LOGIN.name,
                rota = Paginas.LOGIN.rota,
                onClick = { onClick(Paginas.LOGIN.rota) },
                isMobile = isMobile
            )

            BotaoDesfalecido(
                nome = Paginas.SIGNUP.name,
                rota = Paginas.SIGNUP.rota,
                onClick = {
                    onClick(Paginas.SIGNUP.rota)},
                isMobile = isMobile
            )
        }
    }

}
